import { render, staticRenderFns } from "./PolicyValidation.vue?vue&type=template&id=3adc2bcc&scoped=true&"
import script from "./PolicyValidation.vue?vue&type=script&lang=js&"
export * from "./PolicyValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc2bcc",
  null
  
)

export default component.exports